/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantExcludingFcmMessageIdFcmTokenWithRelations } from './tenantExcludingFcmMessageIdFcmTokenWithRelations';
import { UserExcludingFcmMessageIdFcmTokenWithRelations } from './userExcludingFcmMessageIdFcmTokenWithRelations';
import { RoleExcludingFcmMessageIdFcmTokenWithRelations } from './roleExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<UserTenantWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface UserTenantExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    id?: number;
    userId: number;
    tenantId: number;
    roleId: number;
    status: string;
    user?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    tenant?: TenantExcludingFcmMessageIdFcmTokenWithRelations;
    role?: RoleExcludingFcmMessageIdFcmTokenWithRelations;
}

